import Vue from "vue";

import VerifyIdentityConfirmation from "./VerifyIdentityConfirmation.vue";

export function load() {
    const selector = "verify-identity-confirmation";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(VerifyIdentityConfirmation, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}